import React from 'react';
import ErrorModal from '../Common/ErrorModal';
import history from '../../keeperHistory';
import { useFetchQDeckUsersQuery } from '../../api/qdeckApi';
import { userSelector } from '../../selectors/authSelectors';
import { useSelector } from 'react-redux';

const Unauthorized = () => {
  const user = useSelector(userSelector);
  const { data: qdeckUsers = [], isLoading: areQDeckUsersLoading } = useFetchQDeckUsersQuery();

  if (areQDeckUsersLoading) {
    return null;
  }

  const isUserQDeckUser = qdeckUsers.some((qdeckUser) => qdeckUser.email === user.email);

  if (isUserQDeckUser) {
    history.push('/task-list');
  }
  return <ErrorModal errorMsg='You are not authorized to use QDeck :(' />;
};

export default Unauthorized;
